module.exports = __webpack_public_path__ + "static/media/graphql.a109bd9c.svg";